require('/src/com/yext/listingslaunchstorm/js/components/styles/verifyentity.module.scss.module.css');

export const verificationContainer = "_verification-container_1kw5x_1";
export const verificationReason = "_verification-reason_1kw5x_1";
export const verificationReasonIcon = "_verification-reason-icon_1kw5x_1";
export const verificationDetails = "_verification-details_1kw5x_1";
export const verificationMethod = "_verification-method_1kw5x_1";
export const verificationContent = "_verification-content_1kw5x_1";
export const verificationMethodIcon = "_verification-method-icon_1kw5x_1";
export const verificationFormEntry = "_verification-form-entry_1kw5x_1";
export const successLabel = "_success-label_1kw5x_1";
export const verificationMethods = "_verification-methods_1kw5x_1";
export const existingVerificationCode = "_existing-verification-code_1kw5x_1";
export const subTitleText = "_sub-title-text_1kw5x_1";
export const verificationFlowVideoSteps = "_verification-flow-video-steps_1kw5x_1";
export const verificationFlowVideoTipsAction = "_verification-flow-video-tips-action_1kw5x_1";
export const verificationCodeContainer = "_verification-code-container_1kw5x_1";
export const codeCtas = "_code-ctas_1kw5x_1";
export const emailVerification = "_email-verification_1kw5x_1";
export const emailVerificationInput = "_email-verification-input_1kw5x_1";
export const emailDomain = "_email-domain_1kw5x_1";
export const emailVerificationSelection = "_email-verification-selection_1kw5x_1";
export const selectableEmailOptions = "_selectable-email-options_1kw5x_1";
